<template>
  <div>
    <div class="card">
      <Toolbar class="mb-4" v-if="isMaster">
        <template #start>
          <Button
            label="Eintrag löschen"
            icon="pi pi-trash"
            class="p-button-danger"
            @click="confirmDeleteSelected"
            :disabled="!selectedIOs || !selectedIOs.length"
          />
        </template>

        <template #end>
          <Button
            label="Export"
            icon="pi pi-upload"
            class="p-button-help"
            @click="exportCSV($event)"
          />
        </template>
      </Toolbar>

      <!-- LOG TABLE -->
      <DataTable
        ref="dt"
        class="p-datatable-sm"
        :value="alarmLog"
        v-model:selection="selectedIOs"
        dataKey="_id"
        v-model:filters="filters"
        filterDisplay="row"
        sortField="created"
        :sortOrder="-1"
        :globalFilterFields="['label', 'description', 'department', 'category']"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 50, 100, 500]"
        currentPageReportTemplate="zeige {first} bis {last} von {totalRecords} LOG-Einträgen"
        responsiveLayout="stack"
        :loading="loading"
        stripedRows
        :getCategory="getCategory"
      >
        <template #loading> Daten werden geladen... bitte warten </template>
        <template #header>
          <div class="table-header flex justify-content-between">
            <h5 class="mb-0">Alarmübersicht{{ searchModeTxt }}</h5>
            <!-- <span class="p-input-icon-left"><i class="pi pi-search" /><InputText v-model="filters['global'].value" placeholder="suchen..." /></span> -->
            <span class="p-input-icon-left"><i class="pi pi-search" />
              <InputText v-model="searchString" placeholder="suchen..." @keydown.enter="searchAlarm()"/>
              <Button label="Suche löschen" icon="fi-rr-trash" class="p-button-help ml-3" @click="clearSearch" />
              <Button label="Datum" icon="fi-rr-calendar" class="p-button ml-3" @click="openDialog('date')" />
            </span>
          </div>
        </template>
        <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
        <Column field="created" header="Zeitstempel" :sortable="true">
          <template #body="slotProps">
            {{ formatDate(slotProps.data.created) }}
          </template>
        </Column>
        <Column field="department" header="Anlage" :sortable="true" filterField="department" :showFilterMenu="false" >
          <template #body="slotProps">
            <span>{{ slotProps.data.department }}</span>
          </template>
          <template v-if="getDepartments !== null" #filter="{filterModel, filterCallback}">
              <MultiSelect v-model="filterModel.value" @change="filterCallback()" :options="getDepartments" optionLabel="label" optionValue="key" placeholder="Alle" class="p-column-filter">
                  <template #option="slotProps">
                      <div class="p-multiselect-representative-option">
                          <p>{{ slotProps.option.key }} - <span class="text-xs">{{ slotProps.option.label }}</span></p>
                      </div>
                  </template>
                  <template #value="slotProps">
                      <div class="p-multiselect-representative-option">
                          <p v-if="slotProps.value !== null">{{ getOneDepartment(slotProps.value[0]).key }}  - <span class="text-xs">{{ getOneDepartment(slotProps.value[0]).label }}</span></p>
                          <p v-else>{{ slotProps.placeholder }}</p>
                      </div>
                  </template>
              </MultiSelect>
          </template>
        </Column>
        <Column field="category" header="Kategorie" :sortable="true" filterField="category" :showFilterMenu="false" >
          <template #body="slotProps">
            <span>{{ getOneCategory(slotProps.data.category).label }}</span>
          </template>
          <template v-if="getCategory !== null" #filter="{filterModel, filterCallback}">
              <MultiSelect v-model="filterModel.value" @change="filterCallback()" :options="getCategory" optionLabel="label" optionValue="key" placeholder="Alle" class="p-column-filter">
                  <template #option="slotProps">
                      <div class="p-multiselect-representative-option">
                          <p>{{ slotProps.option.label }}</p>
                      </div>
                  </template>
              </MultiSelect>
          </template>
        </Column>
        <Column field="alarmLabel" header="Bezeichnung" :sortable="true" filterField="alarmLabel" :showFilterMenu="false" >
          <template #body="slotProps">
            <span>{{ slotProps.data.alarmLabel }}</span>
          </template>
          <template #filter="{filterModel, filterCallback}">
            <span class="p-input-icon-left"><i class="pi pi-search" /><InputText v-model="filterModel.value" placeholder="suchen..." @keydown.enter="filterCallback()" /></span>
          </template>
        </Column> 
        <Column field="alarmDesc" header="Beschreibung" :sortable="true" filterField="alarmDesc" :showFilterMenu="false" >
          <template #body="slotProps">
            <span>{{ slotProps.data.alarmDesc }}</span>
          </template>
          <template #filter="{filterModel, filterCallback}">
            <span class="p-input-icon-left"><i class="pi pi-search" /><InputText v-model="filterModel.value" placeholder="suchen..." @keydown.enter="filterCallback()" /></span>
          </template>
        </Column> 
        <Column field="alarmValueSp" header="Wert eingestellt" :sortable="true" filterField="alarmValueSp" :showFilterMenu="false" >
          <template #body="slotProps">
            <span>{{ formatValue(slotProps.data.alarmValueSp, slotProps.data.unit, slotProps.data.factor) }}</span>
          </template>
          <template #filter="{filterModel, filterCallback}">
            <span class="p-input-icon-left"><i class="pi pi-search" /><InputText v-model="filterModel.value" placeholder="suchen..." @keydown.enter="filterCallback()" /></span>
          </template>
        </Column> 
        <Column field="alarmValue" header="Wert bei Alarm" :sortable="true" filterField="alarmValue" :showFilterMenu="false" >
          <template #body="slotProps">
            <span>{{ formatValue(slotProps.data.alarmValue, slotProps.data.unit, slotProps.data.factor) }}</span>
          </template>
          <template #filter="{filterModel, filterCallback}">
            <span class="p-input-icon-left"><i class="pi pi-search" /><InputText v-model="filterModel.value" placeholder="suchen..." @keydown.enter="filterCallback()" /></span>
          </template>
        </Column> 
        <!-- <Column field="user" header="Benutzer" :sortable="true" filterField="user" :showFilterMenu="false" >
          <template #body="slotProps">
            <span>{{ slotProps.data.user }}</span>
          </template>
          <template #filter="{filterModel, filterCallback}">
            <span class="p-input-icon-left"><i class="pi pi-search" /><InputText v-model="filterModel.value" placeholder="suchen..." @keydown.enter="filterCallback()" /></span>
          </template>
        </Column>  -->
        <Column field="alarmPrior" header="Priorität" :sortable="true" filterField="alarmPrior" :showFilterMenu="false" >
          <template #body="slotProps">
            <span>{{ formatValue(slotProps.data.alarmPrior, slotProps.data.unit, slotProps.data.factor) }}</span>
          </template>
          <template #filter="{filterModel, filterCallback}">
            <span class="p-input-icon-left"><i class="pi pi-search" /><InputText v-model="filterModel.value" placeholder="suchen..." @keydown.enter="filterCallback()" /></span>
          </template>
        </Column> 
        <Column field="value" header="Zustand" :sortable="true" filterField="value" :showFilterMenu="false" >
          <template #body="slotProps">
            <span v-html="alarmState(slotProps.data.value)"></span>
          </template>
          <template #filter="{filterModel, filterCallback}">
            <span class="p-input-icon-left"><i class="pi pi-search" /><InputText v-model="filterModel.value" placeholder="suchen..." @keydown.enter="filterCallback()" /></span>
          </template>
        </Column> 
      </DataTable>
      <div class="flex justify-content-center">
        <div class="flex-grow-1 text-center" v-if="!searchMode">
          <Button label="weitere Einträge laden" icon="fi-rr-add-document" class="p-button mt-3" :loading="loading" @click="loadMore(event, 'normal')" />
        </div>
        <div class="flex-grow-1 text-center" v-else>
          <Button label="weitere Treffer laden" icon="fi-rr-add-document" class="p-button mt-3" :loading="loading" @click="loadMore(event, 'search')" />
        </div>
      </div>
    </div>
    <div v-if="dialogState.date === true">
      <dialog-date-select v-bind:showDialog="dialogState.date" :dialogObj="ioObj" :dateTime="dateTime" v-bind:dialogData="ioDialogData"
        @entrySave="
          ($value) => {
            // changeDate(null, $value);
            searchAlarm(null, $value);
          }
        " @entryAbort="hideDialog('date')"></dialog-date-select>
    </div>
  </div>

  <Dialog
    v-model:visible="deleteProductDialog"
    :style="{ width: '450px' }"
    header="Bestätigung"
    :modal="true"
  >
    <div class="confirmation-content">
      <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
      <span v-if="selectedIOs"
        >Soll der Eintrag wirklich aus der Datenbank gelöscht werden: <br />
        <b>{{ selectedIOs }}</b> ?</span
      >
    </div>
    <template #footer>
      <Button
        label="Nein"
        icon="pi pi-times"
        class="p-button-text"
        @click="deleteProductDialog = false"
      />
      <Button
        label="Ja"
        icon="pi pi-check"
        class="p-button-text"
        @click="deleteProduct"
      />
    </template>
  </Dialog>

  <Dialog
    v-model:visible="deleteProductsDialog"
    :style="{ width: '450px' }"
    header="Bestätigung"
    :modal="true"
  >
    <div class="confirmation-content">
      <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
      <span v-if="selectedIOs"
        >Sollen die Einträge wirklich aus der Datenbank gelöscht werden?</span
      >
    </div>
    <template #footer>
      <Button
        label="Nein"
        icon="pi pi-times"
        class="p-button-text"
        @click="deleteProductsDialog = false"
      />
      <Button
        label="Ja"
        icon="pi pi-check"
        class="p-button-text"
        @click="deleteSelectedProducts"
      />
    </template>
  </Dialog>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import { mapGetters } from "vuex";
import SocketioService from '@/services/socketioService';
import { formatDateLog, formatDateDay, formatValue, mongoResponseToast } from '@/helpers';
import dialogDateSelect from '@/components/dialog/dialogDateSelect.vue';

export default {
  name: "alarmLog",
  data() {
    return {
      loading: false,
      alarmLog: [],
      filters: null,
      submitted: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      selectedIOs: null,
      logPage: 0,
      logRows: 50,
      searchMode: false,
      searchDate: false,
      searchString: null,
      dateTime: {
        start: 0,
        end: 0,
        format: null
      },
      dialogState: {
        date: false,
      },
      ioDialogData: {},
      nodes: [],
      ioObj: [],
      entryDialog: false,
    };
  },
  components: {
    dialogDateSelect,
  },
  created() {
    this.initFilters();
    this.$store.dispatch('types/loadCategoryTypes');
    this.$store.dispatch('types/loadDepartmentTypes');
    this.$store.dispatch('types/loadIconTypes');
  },
  mounted() {
    this.loading = true;
    this.changeDate('24h');
    this.getParameter();
  },
  beforeUnmount() {
    this.alarmLog = [];
    this.filters = null;
    this.submitted = false;
    this.loading = false;
    this.searchString = null;
    this.searchMode = false;
    this.searchDate = false;
  },
  computed: {
    ...mapGetters({
      getUserGroup: 'users/getUserGroups',
      getCategory: 'types/getCategory',
      getOneCategory: 'types/getOneCategory',
      getDepartments: 'types/getDepartments',
      getOneDepartment: 'types/getOneDepartment',
      getUnits: 'types/getUnits',
      getIcons: 'types/getIcons',
      isMaster: 'auth/isMaster',
    }),
    searchModeTxt: function () {
      if (this.searchMode || this.searchDate) {
        return ' - Suchmodus aktiv!';
      }
      return '';
    },
  },
  methods: {
    loadMore(e, tag) {
      if (tag === 'normal') this.getParameter();
      if (tag === 'search') this.searchAlarm(e);
    },
    getParameter(query) {
      let qry = {};
      this.loading = true;

      if (query) qry = query;

      const options = {
        sort: { created: -1 },
        skip: this.logPage,
        limit: this.logRows
      };
      SocketioService.getAlarmLog(options, qry, (err, response) => {
        if (!err && response !== null) {
          this.alarmLog.push(...response);
          this.logPage = this.logPage+this.logRows;
          this.loading = false;
          console.log(this.logPage);
        }
      });      
    },
    findAlarm(key, find) {
      this.loading = true;
      if (!this.searchMode) {
        this.searchMode = true;
        this.alarmLog = [];
      }

      const options = {
        sort: { timestamp: -1 },
        skip: this.logPage,
        limit: this.logRows
      };
      const query = {
        [key]: find
      };
      SocketioService.getAlarmLog(options, query, (err, response) => {
        if (!err && response !== null) {
          this.alarmLog.push(...response);
          this.logPage = this.logPage+this.logRows;
          this.loading = false;
          console.log(this.logPage);
        }
      }); 
    },
    searchAlarm(find, date) {
      this.loading = true;
      let query = {};
      // let alarmState;
      if (date) {
        this.searchDate = true;
        this.changeDate(null, date);
      }
      if (!this.searchMode) {
        this.searchMode = true;
        this.alarmLog = [];
        this.logPage = 0;
        console.log(find);
      //   if (typeof this.searchString !== 'string') this.searchString = "";
      //   if (this.searchString === "kommt") alarmState = "1";
      //   else if (this.searchString === "geht") alarmState = "0";
      //   else if (this.searchString === "quittiert") alarmState = "-1";
      //   else alarmState = "";
      }

      const queryDate = {
        created: {
          gte: this.dateTime.start,
          lte: this.dateTime.end
        }
      };
      const options = {
        sort: { created: -1 },
        skip: this.logPage,
        limit: this.logRows
      };
      const querySearch = {
        $or: [
          { alarmLabel: { $regex: this.searchString, $options: "i" } },
          { alarmDesc: { $regex: this.searchString, $options: "i" } },
          { alarmParameter: { $regex: this.searchString, $options: "i" } },
          { department: { $regex: this.searchString, $options: "i" } },
        ],
      };
      if (date || this.searchDate) {
        query = { ...querySearch, ...queryDate};
      } else {
        query = { ...querySearch};
      }
      SocketioService.getAlarmLog(options, query, (err, response) => {
        if (!err && response !== null) {
          this.alarmLog.push(...response);
          this.logPage = this.logPage+this.logRows;
          this.loading = false;
          console.log(this.logPage);
        }
      }); 
    },
    clearSearch() {
      this.searchString = null;
      this.searchDate = false;
      this.searchMode = false;
      this.alarmLog = [];
      this.getParameter();
    },
    openDialog(name) {
      if (name) {
        this.dialogState[name] = true;
      } else {
        this.entryDialog = true;
      }
    },
    hideDialog(name) {
      if (name) {
        this.dialogState[name] = false;
      } else {
        this.entryDialog = false;
      }
      // clearInterval(this.intval_Value);
      // this.getUserList();
    },
    changeDate(startDate, dateTime) {
      let dateTimeFormat, dateTimeSelectStart, dateTimeSelectEnd;
      const offset = (this.hoursOffset * 60 * 60 * 1000);

      if (dateTime && typeof(dateTime) === 'object') {
        dateTimeFormat = dateTime.format;
        dateTimeSelectStart = dateTime.start;
        dateTimeSelectEnd = dateTime.end;
        // this.hoursOffset = 0;
        if (this.dialogState.date) this.hideDialog('date');
      } else {
        dateTimeFormat = '%d.%m.%Y - %H:%Mh';
      }

      if (startDate === '12h') {
				dateTimeSelectStart = new Date(Date.now() - (12 * 60 * 60 * 1000));
			}
      else if (startDate === '24h') {
				dateTimeSelectStart = new Date(Date.now() - (24 * 60 * 60 * 1000));
			}
      else if (startDate === '48h') {
				dateTimeSelectStart = new Date(Date.now() - (2 * 24 * 60 * 60 * 1000));
			}
      else if (startDate === '7d') {
				dateTimeSelectStart = new Date(Date.now() - (7 * 24 * 60 * 60 * 1000));
				dateTimeFormat = '%d.%m.%Y - %H:';
			}
      else if (startDate === '30d') {
				dateTimeSelectStart = new Date(Date.now() - (30 * 24 * 60 * 60 * 1000));
				dateTimeFormat = '%d.%m.%Y - %Hh';
			}
      else if (startDate === '2m') {
				dateTimeSelectStart = new Date(Date.now() - (60 * 24 * 60 * 60 * 1000));
				dateTimeFormat = '%d.%m.%Y - %Hh';
			}
      else if (startDate === '1y') {
				dateTimeSelectStart = new Date(Date.now() - (365 * 24 * 60 * 60 * 1000));
				dateTimeFormat = '%d.%m.%Y';
			}

      if (offset > 0) {
        dateTimeSelectEnd = new Date(Date.now() - offset);
        dateTimeSelectStart = new Date(Date.now() - (offset + (24 * 60 * 60 * 1000)));
      }

			if (!dateTimeSelectEnd) dateTimeSelectEnd = new Date(Date.now());
      if (!dateTimeSelectStart) dateTimeSelectStart = new Date(Date.now() - (24 * 60 * 60 * 1000));
      const diff = dateTimeSelectEnd - dateTimeSelectStart;
      console.log(diff);
      if (diff <= (24 * 60 * 60 * 1000)) dateTimeFormat = '%d.%m - %H:';
      else if (diff <= (2 * 24 * 60 * 60 * 1000)) dateTimeFormat = '%d.%m.%Y - %H:';
      else if (diff <= (7 * 24 * 60 * 60 * 1000)) dateTimeFormat = '%d.%m.%Y - %H:';
      else if (diff <= (30 * 24 * 60 * 60 * 1000)) dateTimeFormat = '%d.%m.%Y - %Hh';
      else if (diff <= (60 * 24 * 60 * 60 * 1000)) dateTimeFormat = '%d.%m.%Y - %Hh';
      else if (diff <= (365 * 24 * 60 * 60 * 1000)) dateTimeFormat = '%d.%m.%Y';
      this.dateTime.start = dateTimeSelectStart;
      this.dateTime.end = dateTimeSelectEnd;
      this.dateTime.format = dateTimeFormat;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      if (this.selectedIOs.length > 0) {
        this.selectedIOs.forEach((entry) => {
          SocketioService.delAlarmLog(entry, (err, response) => {
            if (!err && response !== null) {
              this.loading = false;
              const result = mongoResponseToast(response, this.$root);
              if (result) this.getPageData();
            }
          });
        }); 
      }
      this.deleteProductsDialog = false;
      this.selectedIOs = null;
    },
    initFilters() {
      this.filters = {
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'category': { value: null, matchMode: FilterMatchMode.EQUALS },
        'department': { value: null, matchMode: FilterMatchMode.EQUALS },
        'label': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        'description': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        'alarmLabel': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'alarmDesc': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'alarmValueSp': { value: null, matchMode: FilterMatchMode.EQUALS },
        'alarmValue': { value: null, matchMode: FilterMatchMode.EQUALS },
        'user': { value: null, matchMode: FilterMatchMode.EQUALS },
        'alarmPrior': { value: null, matchMode: FilterMatchMode.EQUALS },
        'value': { value: null, matchMode: FilterMatchMode.EQUALS },
      };
    },
    formatDate(timestamp) {
      return formatDateLog(timestamp);
    },
    formatDateDay(timestamp) {
      return formatDateDay(timestamp);
    },
    formatValue(value, unit) {
      return formatValue(value, unit);
    },
    alarmState(value) {
      if (value === "1") return '<span class="fg-lightRed">kommt</span>';
      else if (value === "0") return '<span class="fg-lightGreen">geht</span>';
      else if (value === "-1") return '<span class="fg-lightBlue">quittiert</span>';
    }
  },
};
</script>

<style lang="scss" scoped>
</style>